


































































import { Component, Prop, Watch } from "vue-property-decorator";
import {Element} from "@api/models/Element";
import SessionCard from "@share/common/session-card/SessionCard.vue";
import AgendasFilter from "../filter/AgendasFilter.vue";
import { CardColor } from '@share/common/cards/types/CardColor';
import { CardType } from '@share/common/cards/types/CardType';
import { DateTime } from "luxon";
import { SessionTypeEnum } from "@api/enums/Session/SessionTypeEnum";
import { FilteringParams, getFiltered } from "./helpers";
import AgendaFilterDateSwitcher from '@share/date-switcher/AgendaFilterDateSwitcher.vue'
import { EventInterface } from "@share/program/types/EventInterface";
import EventTypeSelectPanel from "@share/common/event-type-select/EventTypeSelectPanel.vue";
import CardsSectionBase from "@share/common/cards-section/CardsSectionBase.vue";
import CardsSectionGrid from "@share/common/cards-section/CardsSectionGrid.vue";
import CardsSectionLimiter from "@share/common/cards-section/CardsSectionLimiter.vue";
import { mainActions } from "@service/store/main/actions";

@Component({
    components: { SessionCard, AgendasFilter, AgendaFilterDateSwitcher, EventTypeSelectPanel, CardsSectionGrid, CardsSectionLimiter }
})

export default class SessionCardsSection extends CardsSectionBase {

    @Prop() items: EventInterface[];
    @Prop({ default: null }) partners: Element[] | null;
    @Prop() cardType: CardType;
    @Prop() color: CardColor;
    @Prop({ default: false }) filteringAllowed: boolean;

    // TODO: calculate title in getter by cardType
    @Prop({ default: "" }) title: string;
    @Prop({ default: true }) showTitle: boolean;

    selectedDate: DateTime | null = null;
    selectedItemTypes: SessionTypeEnum[] = [];
    selectedTagsIds: string[] = [];
    keyword = "";

    showAll = false;
    CardType = CardType;

    @Watch('showAll')
    watchShowAll() {
        this.$emit('expanded')
    }

    clearFilterState() {
        this.selectedItemTypes = [];
        this.selectedTagsIds = [];
        this.selectedDate = null;
    }

    // FILTERING:
    filterTz(offsetValue: string) {
        this.$store.dispatch(mainActions.setSelectedTimeZone, offsetValue);
    }

    filterType(selectedItemTypes: SessionTypeEnum[]) {
        this.selectedItemTypes = selectedItemTypes;
    }

    filterDate(date: DateTime) {
        this.selectedDate = date;
    }

    filterTags(tagsIds: string[]) {
        this.selectedTagsIds = tagsIds;
    }

    filterKeyword(keyword = "") {
        this.keyword = keyword;
    }

    get filterHasValue() {
        return this.selectedDate || this.selectedItemTypes.length || this.selectedTagsIds.length || this.keyword
    }

    get currentFilterState(): FilteringParams {
        return {
            sessionTypes: this.selectedItemTypes,
            date: this.selectedDate,
            timeZone: this.selectedTimeZone,
            tagsIds: this.selectedTagsIds,
            keyword: this.keyword
        }
    }

    get filteredSessions() {
        return !this.filteringAllowed ? this.items : getFiltered(this.currentFilterState, this.items);
    }

    get offset() {
        return this.$store.state.timeZoneOffset;
    }

    get buttonTitle() {
        switch (this.cardType) {
            case CardType.now:
                return this.$t("common.join").toString();

            case CardType.past:
                return this.$t("agenda.watch").toString();

            default:
                return "";
        }
    }

    get itemsForRender() {
        if(this.thresholdCount && this.filteredSessions.length > this.thresholdCount && !this.showAll) {
            return this.filteredSessions.slice(0, this.thresholdCount)
        }

        return this.filteredSessions
    }

    get sizeClass() {
        return this.getSizeClass(this.items);
    }

    get showAddSession() {
        return this.itemsForRender.length < 8 && this.cardType === "upcoming" && this.isOnEditing;
    }

    get isOnEditing() {
        return this.$store.state.isOnEditing;
    }

    getPartnerById(id: string | undefined) {
        if(this.partners && id) {
            return this.partners.find((partner) => partner.id === id)
        }
    }
}
